import { render, staticRenderFns } from "./GetBBRData.vue?vue&type=template&id=e3490f22&scoped=true&"
import script from "./GetBBRData.vue?vue&type=script&lang=js&"
export * from "./GetBBRData.vue?vue&type=script&lang=js&"
import style0 from "./GetBBRData.vue?vue&type=style&index=0&id=e3490f22&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3490f22",
  null
  
)

export default component.exports